import React, { PureComponent } from 'react';

import { getPremiumBadgeLabel } from '../../utils/premiumBadge';

const ExtraLongBedSeat = ({
  centerColor = '#7E5DDE',
  legRestsColor = '#E2DDFF',
  strokeColor = '#7E5DDE',
}) => (
  <svg
    width="42"
    height="62"
    viewBox="0 0 42 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.6349 28.3899L35.6345 28.4844L34.4711 28.4798L34.4715 28.3853L33.3081 28.3806L33.3078 28.4751L32.1444 28.4705L32.1448 28.376L30.9814 28.3714L30.981 28.4659L29.8176 28.4612L29.818 28.3667L28.6546 28.3621L28.6543 28.4566L27.4909 28.452L27.4913 28.3574L26.3279 28.3528L26.3275 28.4473L25.1641 28.4427L25.1645 28.3482L24.0012 28.3435L24.0008 28.4381L22.8374 28.4334L22.8378 28.3389L21.6744 28.3343L21.674 28.4288L20.5107 28.4242L20.511 28.3296L19.3477 28.325L19.3473 28.4195L18.1839 28.4149L18.1843 28.3204L17.0209 28.3157L17.0205 28.4103L15.8572 28.4056L15.8575 28.3111L14.6942 28.3065L14.6938 28.401L13.5304 28.3964L13.5308 28.3018L12.3674 28.2972L12.3671 28.3917L11.2037 28.3871L11.2041 28.2926L10.0407 28.2879L10.0403 28.3825L8.87693 28.3778L8.87731 28.2833L7.71394 28.2787L7.71356 28.3732L6.55019 28.3686L6.55056 28.274L6.07601 28.2722L6.13341 27.8296L6.03967 27.8174L6.18202 26.7198L6.27576 26.732L6.4181 25.6344L6.32436 25.6222L6.46671 24.5246L6.56045 24.5368L6.7028 23.4392L6.60906 23.427L6.75141 22.3294L6.84515 22.3415L6.98749 21.2439L6.89375 21.2318L7.0361 20.1342L7.12984 20.1463L7.27219 19.0487L7.17845 19.0365L7.3208 17.9389L7.41454 17.9511L7.55688 16.8535L7.46314 16.8413L7.60549 15.7437L7.69923 15.7559L7.84158 14.6583L7.74784 14.6461L7.89019 13.5485L7.98393 13.5606L8.12628 12.463L8.03254 12.4509L8.17488 11.3533L8.26862 11.3654L8.41097 10.2678L8.31723 10.2557L8.45958 9.15804L8.55332 9.1702L8.69567 8.07259L8.60193 8.06043L8.74427 6.96282L8.83801 6.97497L8.98036 5.87736L8.88662 5.8652L9.02897 4.76759L9.12271 4.77975L9.26506 3.68214L9.17132 3.66998L9.31367 2.57237L9.4074 2.58453L9.47858 2.03571C9.51334 1.76772 9.59588 1.5166 9.7169 1.29032L9.63355 1.24574C9.89413 0.758552 10.3257 0.381499 10.8435 0.188734L10.8765 0.277319C11.117 0.187789 11.3769 0.139728 11.6472 0.14129L12.1978 0.144472L12.1983 0.0499486L13.2995 0.0563121L13.299 0.150835L14.4002 0.157199L14.4007 0.0626756L15.5019 0.0690391L15.5014 0.163562L16.6026 0.169926L16.6031 0.0754027L17.7043 0.0817662L17.7038 0.176289L18.805 0.182653L18.8055 0.0881297L19.9067 0.0944933L19.9062 0.189016L21.0074 0.19538L21.0079 0.100857L22.1091 0.10722L22.1086 0.201744L23.2098 0.208107L23.2103 0.113584L24.3115 0.119947L24.311 0.214471L25.4122 0.220834L25.4127 0.126311L26.5139 0.132674L26.5134 0.227198L27.6146 0.233561L27.6151 0.139038L28.7163 0.145401L28.7158 0.239925L29.817 0.246288L29.8175 0.151765L30.9187 0.158129L30.9182 0.252652L31.4688 0.255834C31.7435 0.257421 32.0068 0.310109 32.2492 0.405151L32.2837 0.317146C32.8062 0.521968 33.2363 0.915366 33.4869 1.41756L33.4023 1.45975C33.5185 1.69278 33.5945 1.95031 33.6205 2.22379L33.6726 2.77112L33.7667 2.76216L33.871 3.85682L33.7769 3.86578L33.8811 4.96044L33.9752 4.95148L34.0794 6.04615L33.9853 6.05511L34.0896 7.14977L34.1837 7.14081L34.2879 8.23547L34.1938 8.24443L34.298 9.33909L34.3921 9.33013L34.4964 10.4248L34.4023 10.4338L34.5065 11.5284L34.6006 11.5195L34.7048 12.6141L34.6107 12.6231L34.7149 13.7177L34.809 13.7088L34.9133 14.8034L34.8192 14.8124L34.9234 15.9071L35.0175 15.8981L35.1217 16.9928L35.0276 17.0017L35.1319 18.0964L35.226 18.0874L35.3302 19.1821L35.2361 19.1911L35.3403 20.2857L35.4344 20.2768L35.5387 21.3714L35.4446 21.3804L35.5488 22.475L35.6429 22.4661L35.7471 23.5607L35.653 23.5697L35.7573 24.6644L35.8514 24.6554L35.9556 25.7501L35.8615 25.759L35.9657 26.8537L36.0598 26.8447L36.1641 27.9394L36.07 27.9484L36.1122 28.3918L35.6349 28.3899Z"
      fill={legRestsColor}
      stroke={strokeColor}
      strokeWidth="0.18905"
      strokeDasharray="2"
    />
    <path
      d="M6.35514 60.2988C6.13916 59.9734 5.9845 59.6039 5.90758 59.2067L6.00038 59.1888C5.96453 59.0037 5.9461 58.8124 5.94688 58.6166L5.94889 58.1124L5.85436 58.1121L5.85838 57.1038L5.9529 57.1042L5.95692 56.0959L5.86239 56.0955L5.86641 55.0873L5.96093 55.0877L5.96495 54.0794L5.87043 54.079L5.87444 53.0708L5.96897 53.0712L5.9706 52.6616L6.45777 52.6635L6.45814 52.569L7.62152 52.5736L7.62114 52.6681L8.78451 52.6728L8.78489 52.5782L9.94826 52.5829L9.94788 52.6774L11.1113 52.682L11.1116 52.5875L12.275 52.5921L12.2746 52.6867L13.438 52.6913L13.4384 52.5968L14.6018 52.6014L14.6014 52.6959L15.7647 52.7006L15.7651 52.606L16.9285 52.6107L16.9281 52.7052L18.0915 52.7098L18.0919 52.6153L19.2552 52.6199L19.2549 52.7145L20.4182 52.7191L20.4186 52.6246L21.582 52.6292L21.5816 52.7237L22.745 52.7284L22.7454 52.6338L23.9087 52.6385L23.9084 52.733L25.0717 52.7376L25.0721 52.6431L26.2355 52.6477L26.2351 52.7423L27.3985 52.7469L27.3988 52.6524L28.5622 52.657L28.5618 52.7515L29.7252 52.7562L29.7256 52.6616L30.889 52.6663L30.8886 52.7608L32.052 52.7654L32.0523 52.6709L33.2157 52.6755L33.2153 52.7701L34.3787 52.7747L34.3791 52.6802L35.5425 52.6848L35.5421 52.7793L36.0292 52.7813L36.0276 53.1909L36.1221 53.1913L36.1181 54.1995L36.0236 54.1991L36.0196 55.2074L36.1141 55.2078L36.1101 56.216L36.0156 56.2156L36.0115 57.2239L36.1061 57.2243L36.1021 58.2325L36.0075 58.2322L36.0055 58.7363C36.0047 58.9321 35.9848 59.1233 35.9475 59.308L36.0401 59.3268C35.96 59.7233 35.8024 60.0916 35.5839 60.4152L35.5055 60.3623C35.2903 60.6811 35.014 60.9552 34.6936 61.1678L34.7459 61.2466C34.4205 61.4626 34.0509 61.6172 33.6538 61.6942L33.6358 61.6014C33.4507 61.6372 33.2594 61.6556 33.0636 61.6549L32.5136 61.6527L32.5133 61.7472L31.4134 61.7428L31.4137 61.6483L30.3138 61.6439L30.3134 61.7384L29.2135 61.7341L29.2139 61.6395L28.114 61.6351L28.1136 61.7297L27.0137 61.7253L27.0141 61.6308L25.9142 61.6264L25.9138 61.7209L24.8139 61.7165L24.8142 61.622L23.7143 61.6176L23.7139 61.7121L22.614 61.7078L22.6144 61.6132L21.5145 61.6089L21.5141 61.7034L20.4142 61.699L20.4146 61.6045L19.3147 61.6001L19.3143 61.6946L18.2144 61.6902L18.2147 61.5957L17.1148 61.5913L17.1144 61.6859L16.0145 61.6815L16.0149 61.587L14.915 61.5826L14.9146 61.6771L13.8147 61.6727L13.8151 61.5782L12.7152 61.5738L12.7148 61.6683L11.6149 61.664L11.6152 61.5694L10.5153 61.5651L10.515 61.6596L9.41504 61.6552L9.41541 61.5607L8.86545 61.5585C8.66964 61.5577 8.47847 61.5377 8.2937 61.5004L8.27499 61.5931C7.87847 61.513 7.51016 61.3554 7.1865 61.1368L7.2394 61.0585C6.92066 60.8433 6.64658 60.567 6.43389 60.2466L6.35514 60.2988Z"
      fill={legRestsColor}
      stroke={strokeColor}
      strokeWidth="0.18905"
      strokeDasharray="2"
    />
    <path
      d="M9.01063 25.1672L33.2088 25.2635C34.7749 25.2698 36.0395 26.5444 36.0332 28.1106L35.9368 52.3087C35.9306 53.8748 34.6559 55.1394 33.0898 55.1331L8.89167 55.0368C7.32554 55.0305 6.061 53.7559 6.06724 52.1897L6.16362 27.9916C6.16986 26.4255 7.44451 25.1609 9.01063 25.1672Z"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
    <rect
      x="6.07846"
      y="49.3539"
      width="29.8698"
      height="5.67149"
      rx="2.83574"
      transform="rotate(0.228203 6.07846 49.3539)"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
    <rect
      x="35.5553"
      y="53.2531"
      width="17.7707"
      height="5.67149"
      rx="2.83574"
      transform="rotate(-89.7718 35.5553 53.2531)"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
    <rect
      x="0.770032"
      y="53.1135"
      width="17.7707"
      height="5.67149"
      rx="2.83574"
      transform="rotate(-89.7718 0.770032 53.1135)"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
  </svg>
);

const StandardSeat = ({
  centerColor = '#E7E7E7',
  legRestsColor = '#F7F7F7',
  strokeColor = '#E7E7E7',
}) => (
  <svg
    width="42"
    height="50"
    viewBox="0 0 42 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35.3386 16.0204L35.3384 16.1149L34.1751 16.113L34.1752 16.0184L33.0118 16.0165L33.0117 16.111L31.8483 16.1091L31.8485 16.0146L30.6851 16.0126L30.6849 16.1072L29.5215 16.1052L29.5217 16.0107L28.3583 16.0088L28.3582 16.1033L27.1948 16.1014L27.1949 16.0068L26.0316 16.0049L26.0314 16.0994L24.868 16.0975L24.8682 16.003L23.7048 16.001L23.7046 16.0956L22.5413 16.0936L22.5414 15.9991L21.378 15.9972L21.3779 16.0917L20.2145 16.0898L20.2147 15.9952L19.0513 15.9933L19.0511 16.0878L17.8877 16.0859L17.8879 15.9914L16.7245 15.9894L16.7244 16.084L15.561 16.082L15.5611 15.9875L14.3978 15.9856L14.3976 16.0801L13.2342 16.0782L13.2344 15.9836L12.071 15.9817L12.0708 16.0762L10.9075 16.0743L10.9076 15.9798L9.74424 15.9778L9.74409 16.0724L8.58071 16.0704L8.58086 15.9759L7.41749 15.974L7.41733 16.0685L6.25395 16.0666L6.2541 15.972L5.78139 15.9713L5.84514 15.5302L5.75159 15.5167L5.91028 14.419L6.00383 14.4325L6.16251 13.3347L6.06896 13.3212L6.22764 12.2235L6.3212 12.237L6.47988 11.1392L6.38633 11.1257L6.54501 10.0279L6.63857 10.0415L6.79725 8.94371L6.7037 8.93019L6.86238 7.83244L6.95593 7.84596L7.11462 6.74821L7.02107 6.73468L7.17975 5.63693L7.2733 5.65045L7.43199 4.5527L7.33844 4.53917L7.49712 3.44142L7.59067 3.45494L7.67001 2.90607C7.70814 2.64228 7.79258 2.39544 7.91431 2.17315L7.8314 2.12775C8.09331 1.64952 8.52076 1.28004 9.03186 1.0901L9.06478 1.1787C9.30234 1.09042 9.55881 1.04259 9.82533 1.04304L10.4205 1.04403L10.4206 0.949501L11.6109 0.95148L11.6107 1.046L12.801 1.04798L12.8012 0.953458L13.9915 0.955437L13.9913 1.04996L15.1816 1.05194L15.1817 0.957415L16.372 0.959394L16.3719 1.05392L17.5621 1.0559L17.5623 0.961372L18.7526 0.963351L18.7524 1.05788L19.9427 1.05985L19.9428 0.965329L21.1331 0.967307L21.133 1.06183L22.3232 1.06381L22.3234 0.969286L23.5137 0.971264L23.5135 1.06579L24.7038 1.06777L24.704 0.973243L25.8942 0.975221L25.8941 1.06975L27.0843 1.07172L27.0845 0.9772L28.2748 0.979178L28.2746 1.0737L29.4649 1.07568L29.4651 0.981157L30.6553 0.983135L30.6552 1.07766L31.2503 1.07865C31.5086 1.07908 31.7576 1.12488 31.9891 1.20904L32.0214 1.1202C32.5187 1.30097 32.9387 1.65138 33.2057 2.10816L33.1241 2.15586C33.2484 2.36853 33.3381 2.60529 33.3849 2.8593L33.4866 3.41237L33.5796 3.39527L33.7831 4.50141L33.6902 4.51851L33.8937 5.62465L33.9867 5.60755L34.1902 6.71369L34.0972 6.73079L34.3007 7.83693L34.3937 7.81983L34.5972 8.92596L34.5043 8.94307L34.7078 10.0492L34.8008 10.0321L35.0043 11.1382L34.9113 11.1553L35.1148 12.2615L35.2078 12.2444L35.4113 13.3505L35.3184 13.3676L35.5219 14.4738L35.6149 14.4567L35.8184 15.5628L35.7254 15.5799L35.8066 16.0212L35.3386 16.0204Z"
      fill={legRestsColor}
      stroke={strokeColor}
      strokeWidth="0.18905"
      strokeDasharray="2"
    />
    <path
      d="M6.12837 47.9957C5.91164 47.6708 5.75613 47.3016 5.67828 46.9046L5.77104 46.8865C5.73476 46.7015 5.71589 46.5102 5.71621 46.3144L5.71705 45.8103L5.62253 45.8101L5.6242 44.8018L5.71873 44.802L5.7204 43.7937L5.62588 43.7936L5.62755 42.7853L5.72208 42.7855L5.72376 41.7772L5.62923 41.777L5.63091 40.7688L5.72543 40.7689L5.72611 40.3593L6.21329 40.3601L6.21344 40.2656L7.37682 40.2675L7.37667 40.3621L8.54005 40.364L8.5402 40.2695L9.70358 40.2714L9.70343 40.3659L10.8668 40.3679L10.867 40.2734L12.0303 40.2753L12.0302 40.3698L13.1936 40.3717L13.1937 40.2772L14.3571 40.2792L14.3569 40.3737L15.5203 40.3756L15.5205 40.2811L16.6839 40.283L16.6837 40.3775L17.8471 40.3795L17.8472 40.285L19.0106 40.2869L19.0105 40.3814L20.1738 40.3833L20.174 40.2888L21.3374 40.2908L21.3372 40.3853L22.5006 40.3872L22.5008 40.2927L23.6641 40.2946L23.664 40.3891L24.8274 40.3911L24.8275 40.2966L25.9909 40.2985L25.9907 40.393L27.1541 40.3949L27.1543 40.3004L28.3177 40.3024L28.3175 40.3969L29.4809 40.3988L29.481 40.3043L30.6444 40.3062L30.6443 40.4007L31.8076 40.4027L31.8078 40.3082L32.9712 40.3101L32.971 40.4046L34.1344 40.4066L34.1346 40.312L35.2979 40.314L35.2978 40.4085L35.785 40.4093L35.7843 40.8189L35.8788 40.8191L35.8771 41.8273L35.7826 41.8272L35.7809 42.8354L35.8754 42.8356L35.8738 43.8438L35.7792 43.8437L35.7776 44.852L35.8721 44.8521L35.8704 45.8604L35.7759 45.8602L35.7751 46.3643C35.7747 46.5602 35.7552 46.7514 35.7183 46.9362L35.811 46.9547C35.7319 47.3514 35.5751 47.7201 35.3573 48.0443L35.2788 47.9916C35.0644 48.3108 34.7887 48.5855 34.4688 48.7989L34.5212 48.8776C34.1963 49.0943 33.8272 49.2498 33.4302 49.3277L33.412 49.2349C33.227 49.2712 33.0357 49.2901 32.8399 49.2897L32.29 49.2888L32.2898 49.3834L31.1899 49.3815L31.19 49.287L30.0901 49.2852L30.09 49.3797L28.99 49.3779L28.9902 49.2833L27.8903 49.2815L27.8901 49.376L26.7902 49.3742L26.7903 49.2797L25.6904 49.2779L25.6903 49.3724L24.5903 49.3706L24.5905 49.276L23.4906 49.2742L23.4904 49.3687L22.3905 49.3669L22.3907 49.2724L21.2907 49.2705L21.2906 49.3651L20.1906 49.3632L20.1908 49.2687L19.0909 49.2669L19.0907 49.3614L17.9908 49.3596L17.991 49.2651L16.891 49.2632L16.8909 49.3578L15.791 49.3559L15.7911 49.2614L14.6912 49.2596L14.691 49.3541L13.5911 49.3523L13.5913 49.2577L12.4913 49.2559L12.4912 49.3504L11.3913 49.3486L11.3914 49.2541L10.2915 49.2523L10.2913 49.3468L9.19141 49.345L9.19157 49.2504L8.64161 49.2495C8.44579 49.2492 8.25458 49.2297 8.06972 49.1928L8.05122 49.2855C7.65452 49.2063 7.28585 49.0496 6.96168 48.8318L7.01439 48.7533C6.69516 48.5388 6.42044 48.2632 6.20701 47.9432L6.12837 47.9957Z"
      fill={legRestsColor}
      stroke={strokeColor}
      strokeWidth="0.18905"
      strokeDasharray="2"
    />
    <path
      d="M8.70251 12.8567L32.9008 12.8969C34.467 12.8995 35.7345 14.1712 35.7319 15.7373L35.6916 39.9357C35.689 41.5018 34.4173 42.7693 32.8512 42.7667L8.65287 42.7265C7.08673 42.7239 5.81924 41.4521 5.82184 39.886L5.86206 15.6877C5.86466 14.1216 7.13638 12.8541 8.70251 12.8567Z"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
    <rect
      x="5.82671"
      y="37.05"
      width="29.8698"
      height="5.67149"
      rx="2.83574"
      transform="rotate(0.0952361 5.82671 37.05)"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
    <rect
      x="35.3118"
      y="40.8804"
      width="17.7707"
      height="5.67149"
      rx="2.83574"
      transform="rotate(-89.9048 35.3118 40.8804)"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
    <rect
      x="0.526949"
      y="40.8223"
      width="17.7707"
      height="5.67149"
      rx="2.83574"
      transform="rotate(-89.9048 0.526949 40.8223)"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
  </svg>
);

const UnavailableSeat = ({
  centerColor = '#E1E1E1',
  legRestsColor = '#F7F7F7',
  strokeColor = '#FFFFFF',
}) => (
  <svg
    width="41"
    height="49"
    viewBox="0 0 41 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.9596 15.0294V15.124H33.7962V15.0294H32.6328V15.124H31.4694V15.0294H30.3061V15.124H29.1427V15.0294H27.9793V15.124H26.8159V15.0294H25.6525V15.124H24.4892V15.0294H23.3258V15.124H22.1624V15.0294H20.999V15.124H19.8356V15.0294H18.6722V15.124H17.5089V15.0294H16.3455V15.124H15.1821V15.0294H14.0187V15.124H12.8553V15.0294H11.692V15.124H10.5286V15.0294H9.36519V15.124H8.20181V15.0294H7.03843V15.124H5.87505V15.0294H5.40234L5.46535 14.5883L5.37178 14.575L5.52864 13.4769L5.62221 13.4903L5.77907 12.3923L5.6855 12.3789L5.84236 11.2809L5.93593 11.2943L6.09279 10.1963L5.99922 10.1829L6.15608 9.08488L6.24965 9.09824L6.40651 8.00023L6.31294 7.98686L6.4698 6.88884L6.56337 6.90221L6.72023 5.80419L6.62666 5.79082L6.78352 4.69281L6.87709 4.70618L7.03395 3.60816L6.94038 3.59479L7.09723 2.49678L7.19081 2.51014L7.26924 1.96113C7.30693 1.69729 7.39095 1.4503 7.51232 1.22782L7.42934 1.18255C7.69044 0.703889 8.11728 0.333693 8.62806 0.142903L8.66114 0.231452C8.89855 0.142772 9.15494 0.0945248 9.42146 0.0945248H10.0166V0H11.2069V0.0945248H12.3972V0H13.5874V0.0945248H14.7777V0H15.968V0.0945248H17.1583V0H18.3485V0.0945248H19.5388V0H20.7291V0.0945248H21.9194V0H23.1097V0.0945248H24.2999V0H25.4902V0.0945248H26.6805V0H27.8708V0.0945248H29.0611V0H30.2513V0.0945248H30.8465C31.1047 0.0945248 31.3538 0.139908 31.5855 0.223685L31.6176 0.134795C32.1152 0.314733 32.5358 0.664451 32.8036 1.12078L32.7221 1.16862C32.8467 1.38108 32.9368 1.6177 32.984 1.87163L33.0867 2.42453L33.1796 2.40727L33.385 3.51307L33.292 3.53033L33.4974 4.63613L33.5903 4.61887L33.7957 5.72467L33.7028 5.74193L33.9081 6.84773L34.0011 6.83047L34.2064 7.93627L34.1135 7.95353L34.3189 9.05933L34.4118 9.04207L34.6172 10.1479L34.5242 10.1651L34.7296 11.2709L34.8225 11.2537L35.0279 12.3595L34.9349 12.3767L35.1403 13.4825L35.2332 13.4653L35.4386 14.5711L35.3457 14.5883L35.4276 15.0294H34.9596Z"
      fill={legRestsColor}
      stroke={strokeColor}
      strokeWidth="0.18905"
      strokeDasharray="2"
    />
    <path
      d="M5.80283 47.0525C5.58556 46.7279 5.42943 46.359 5.35092 45.9622L5.44365 45.9438C5.40707 45.7589 5.38788 45.5677 5.38788 45.3719V44.8677H5.29335V43.8595H5.38788V42.8512H5.29335V41.8429H5.38788V40.8347H5.29335V39.8264H5.38788V39.4168H5.87505V39.3223H7.03843V39.4168H8.20181V39.3223H9.36519V39.4168H10.5286V39.3223H11.692V39.4168H12.8553V39.3223H14.0187V39.4168H15.1821V39.3223H16.3455V39.4168H17.5089V39.3223H18.6722V39.4168H19.8356V39.3223H20.999V39.4168H22.1624V39.3223H23.3258V39.4168H24.4892V39.3223H25.6525V39.4168H26.8159V39.3223H27.9793V39.4168H29.1427V39.3223H30.3061V39.4168H31.4694V39.3223H32.6328V39.4168H33.7962V39.3223H34.9596V39.4168H35.4468V39.8264H35.5413V40.8347H35.4468V41.8429H35.5413V42.8512H35.4468V43.8595H35.5413V44.8677H35.4468V45.3719C35.4468 45.5677 35.4276 45.7589 35.391 45.9438L35.4837 45.9622C35.4052 46.359 35.2491 46.7279 35.0318 47.0525L34.9533 46.9999C34.7393 47.3195 34.4641 47.5947 34.1445 47.8086L34.1971 47.8872C33.8726 48.1044 33.5037 48.2606 33.1068 48.3391L33.0885 48.2463C32.9036 48.2829 32.7123 48.3021 32.5165 48.3021H31.9665V48.3966H30.8666V48.3021H29.7667V48.3966H28.6668V48.3021H27.5668V48.3966H26.4669V48.3021H25.367V48.3966H24.2671V48.3021H23.1671V48.3966H22.0672V48.3021H20.9673V48.3966H19.8674V48.3021H18.7674V48.3966H17.6675V48.3021H16.5676V48.3966H15.4677V48.3021H14.3677V48.3966H13.2678V48.3021H12.1679V48.3966H11.068V48.3021H9.96803V48.3966H8.86811V48.3021H8.31814C8.12232 48.3021 7.93108 48.2829 7.74616 48.2463L7.72782 48.3391C7.33098 48.2606 6.96206 48.1044 6.63752 47.8872L6.69011 47.8086C6.37052 47.5947 6.09534 47.3195 5.88138 46.9999L5.80283 47.0525Z"
      fill={legRestsColor}
      stroke={strokeColor}
      strokeWidth="0.18905"
      strokeDasharray="2"
    />
    <path
      d="M8.31814 11.9105H32.5165C34.0826 11.9105 35.3522 13.1801 35.3522 14.7462V38.9446C35.3522 40.5107 34.0826 41.7803 32.5165 41.7803H8.31814C6.75201 41.7803 5.4824 40.5107 5.4824 38.9446V14.7462C5.4824 13.1801 6.75201 11.9105 8.31814 11.9105Z"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
    <rect
      x="5.4824"
      y="36.109"
      width="29.8698"
      height="5.67149"
      rx="2.83574"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
    <rect
      x="34.9742"
      y="39.8888"
      width="17.7707"
      height="5.67149"
      rx="2.83574"
      transform="rotate(-90 34.9742 39.8888)"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
    <rect
      x="0.18905"
      y="39.8888"
      width="17.7707"
      height="5.67149"
      rx="2.83574"
      transform="rotate(-90 0.18905 39.8888)"
      fill={centerColor}
      stroke={strokeColor}
      strokeWidth="0.378099"
    />
    <path
      d="M11.6321 15.6855L29.1321 33.1855"
      stroke={strokeColor}
      strokeLinecap="square"
    />
    <path
      d="M11.6321 33.6855L29.1321 16.1855"
      stroke={strokeColor}
      strokeLinecap="square"
    />
  </svg>
);

const longSeatCategories = [
  'First Class Single Suite',
  'First Class Seat Plus',
  'Business Extra Long Bed',
];

const getSeatIcon = (seatCategory, theme, selected) => {
  const themeColor = theme?.seats?.[seatCategory?.rank];
  const fillColor = selected
    ? theme?.seats?.selected_seat?.fill
    : themeColor?.fill;
  const stopColor = selected
    ? theme?.seats?.selected_seat?.stopColor
    : themeColor?.stopColor;
  const strokeColor = selected
    ? theme?.seats?.selected_seat?.strokeColor
    : themeColor?.strokeColor;
  const isAllegris = theme.isAllegris;

  const centerColor = isAllegris ? fillColor : stopColor;
  const legRestsColor = isAllegris ? stopColor : fillColor;

  return longSeatCategories.includes(seatCategory?.display_name) ? (
    <ExtraLongBedSeat
      centerColor={centerColor}
      legRestsColor={legRestsColor}
      strokeColor={strokeColor}
    />
  ) : (
    <StandardSeat
      centerColor={centerColor}
      legRestsColor={legRestsColor}
      strokeColor={strokeColor}
    />
  );
};

export default class PremiumSeatIcon extends PureComponent {
  render() {
    const {
      seat,
      theme,
      rotation,
      seatCategory,
      unavailable = false,
      selected = false,
    } = this.props;

    const seatIcon = unavailable ? (
      <UnavailableSeat
        centerColor={theme?.seats?.['not_available']?.fill}
        legRestsColor={theme?.seats?.['not_available']?.stopColor}
        strokeColor={theme?.seats?.['not_available']?.strokeColor}
      />
    ) : (
      getSeatIcon(seatCategory, theme, selected)
    );

    const isLongBedSeat = longSeatCategories.includes(
      seatCategory?.display_name
    );

    const translateLongSeat = isLongBedSeat ? '-6px' : '0px';

    const badgeLabel = unavailable
      ? null
      : getPremiumBadgeLabel(theme, seatCategory);

    return (
      <div
        style={{
          transform: `rotate(${rotation?.value}deg) translateY(${translateLongSeat})`,
        }}
      >
        {selected ? (
          <span
            className={'gr-premium-seat-selected-text'}
            style={{
              top: `${isLongBedSeat ? '63%' : ''}`,
            }}
          >
            {seat}
          </span>
        ) : null}
        {seatIcon}
        {badgeLabel ? (
          <span
            className="gordian-premium-badge"
            // Counter-rotate so the text stays upright on rotated cabins.
            style={
              rotation?.value
                ? { transform: `rotate(${-rotation.value}deg)` }
                : undefined
            }
          >
            {badgeLabel}
          </span>
        ) : null}
      </div>
    );
  }
}
